(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-product-photo-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ace-product-photo-strip')) {
  customElements.define('ace-product-photo-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.group = this.closest('[data-ace-photo-group]');
      this.isCase = this.classList.contains('ace-photo-strip--cases');
      this.viewport = this.querySelector('.ace-photo-strip__viewport');
      this.track = this.querySelector('.ace-photo-strip__track');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.pause = this.querySelector('[data-pause]');
      this.status = this.querySelector('[data-status]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hoverPaused = false;
      this.focusPaused = false;
      this.animating = false;
      const cards = Array.from(this.track.children);
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      this.track.replaceChildren(...cards);
      this.setAttribute('data-enhanced', '');
      this.previous.hidden = false;
      this.querySelector('.ace-photo-strip__controls').hidden = false;
      this.previous.addEventListener('click', () => this.move(-1, true), { signal });
      this.next.addEventListener('click', () => this.move(1, true), { signal });
      this.pause.addEventListener('click', () => {
        const paused = !this.userPaused;
        this.group.querySelectorAll('ace-product-photo-strip').forEach(row => {
          row.userPaused = paused;
          row.updatePause();
        });
        this.schedule();
      }, { signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1, true);
        }
      }, { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hoverPaused = true;
        this.schedule();
      }, { signal });
      this.addEventListener('pointerleave', () => { this.hoverPaused = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focusPaused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => {
        this.focusPaused = this.contains(document.activeElement);
        this.schedule();
      }), { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.userPaused = true;
        this.updatePause();
        this.schedule();
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        this.userPaused = true;
        this.updatePause();
        this.finishMove();
        const selected = event.target.closest('.ace-photo-strip__item');
        if (selected && this.track.contains(selected)) {
          while (this.track.firstElementChild !== selected) this.track.append(this.track.firstElementChild);
        }
        this.refresh();
      }, { signal });
      this.observer = new ResizeObserver(() => { this.finishMove(); this.refresh(); });
      this.observer.observe(this.viewport);
      this.updatePause();
      this.refresh();
    }
    get visibleCount() {
      return Math.max(1, parseInt(getComputedStyle(this).getPropertyValue('--columns'), 10) || 10);
    }
    updatePause() {
      this.pause.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.pause.setAttribute('aria-pressed', String(this.userPaused));
      this.pause.firstElementChild.textContent = this.userPaused ? '▶' : 'Ⅱ';
    }
    refresh() {
      const count = this.visibleCount;
      if (this.isCase && this.loopColumns !== count) {
        this.track.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
        const originals = Array.from(this.track.children);
        if (originals.length > 1 && originals.length < count) {
          const target = Math.ceil(count / originals.length) * originals.length;
          for (let i = originals.length; i < target; i++) {
            const copy = originals[i % originals.length].cloneNode(true);
            copy.setAttribute('data-loop-copy', '');
            copy.removeAttribute('data-shopify-editor-block');
            copy.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
            this.track.append(copy);
          }
        }
        this.loopColumns = count;
      }
      Array.from(this.track.children).forEach((card, index) => {
        const hidden = index >= count;
        card.inert = hidden;
        if (hidden || card.hasAttribute('data-loop-copy')) card.setAttribute('aria-hidden', 'true');
        else card.removeAttribute('aria-hidden');
      });
      this.canMove = this.track.children.length >= count && this.track.children.length > 1;
      this.toggleAttribute('data-static', !this.canMove);
      this.previous.disabled = !this.canMove;
      this.next.disabled = !this.canMove;
      const rows = Array.from(this.group.querySelectorAll('ace-product-photo-strip'));
      rows.forEach(row => { if (row.pause) row.pause.disabled = !rows.some(item => item.canMove); });
      this.schedule();
    }
    schedule() {
      const rows = Array.from(this.group.querySelectorAll('ace-product-photo-strip'));
      const leader = rows[0];
      clearTimeout(leader.timer);
      if (!this.isConnected || !rows.some(row => row.canMove) || rows.some(row => row.userPaused || row.hoverPaused || row.focusPaused || row.animating) || document.hidden) return;
      leader.timer = setTimeout(() => {
        rows.forEach(row => { if (row.canMove) row.move(1, false); });
      }, Math.max(1000, Number(this.dataset.interval) || 1250));
    }
    move(direction, manual) {
      if (!this.canMove || this.animating) return;
      clearTimeout(this.group.querySelector('ace-product-photo-strip').timer);
      this.animating = true;
      this.pendingDirection = direction;
      this.pendingManual = manual;
      const width = this.track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
      if (this.motion.matches) {
        if (direction < 0) this.track.prepend(this.track.lastElementChild);
        this.finishMove();
        return;
      }
      if (this.track.children.length === this.visibleCount) {
        this.ghost = (direction > 0 ? this.track.firstElementChild : this.track.lastElementChild).cloneNode(true);
        this.ghost.inert = true;
        this.ghost.setAttribute('aria-hidden', 'true');
        this.ghost.removeAttribute('data-product-key');
        this.ghost.removeAttribute('data-shopify-editor-block');
        this.track.append(this.ghost);
      }
      if (direction < 0) {
        this.track.style.transition = 'none';
        this.track.prepend(this.ghost ? this.ghost.previousElementSibling : this.track.lastElementChild);
        this.track.style.transform = `translateX(-${width}px)`;
        void this.track.offsetWidth;
        this.track.style.transition = '';
        this.track.style.transform = 'translateX(0)';
      } else {
        this.track.style.transform = `translateX(-${width}px)`;
      }
      this.animationTimer = setTimeout(() => this.finishMove(), 450);
    }
    finishMove() {
      if (!this.animating) return;
      clearTimeout(this.animationTimer);
      if (this.pendingDirection > 0) this.track.append(this.track.firstElementChild);
      this.ghost?.remove();
      this.ghost = null;
      this.track.style.transition = 'none';
      this.track.style.transform = 'translateX(0)';
      void this.track.offsetWidth;
      this.track.style.transition = '';
      this.animating = false;
      if (this.pendingManual) this.status.textContent = `${this.dataset.updatedLabel} ${this.track.firstElementChild.querySelector('img').alt}`;
      this.refresh();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.animationTimer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

if (!customElements.get('ace-case-photo-mirror')) {
  customElements.define('ace-case-photo-mirror', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      document.addEventListener('shopify:section:load', () => this.render(), { signal: this.controller.signal });
      this.render();
    }
    render() {
      const source = document.querySelector('template[data-ace-case-template]');
      if (source === this.sourceTemplate) return;
      this.sourceTemplate = source;
      if (!source) {
        this.replaceChildren();
        this.hidden = true;
        return;
      }
      const content = source.content.cloneNode(true);
      const row = content.querySelector('ace-product-photo-strip');
      if (!row) {
        this.replaceChildren();
        this.hidden = true;
        return;
      }
      row.dataset.pauseLabel = this.dataset.pauseLabel;
      row.dataset.playLabel = this.dataset.playLabel;
      const ids = new Map();
      content.querySelectorAll('[id]').forEach(element => {
        const oldId = element.id;
        element.id = oldId + '--' + this.dataset.instanceId;
        ids.set(oldId, element.id);
      });
      content.querySelectorAll('[aria-controls]').forEach(element => {
        const id = element.getAttribute('aria-controls');
        if (ids.has(id)) element.setAttribute('aria-controls', ids.get(id));
      });
      content.querySelectorAll('[data-shopify-editor-block]').forEach(element => element.removeAttribute('data-shopify-editor-block'));
      content.querySelectorAll('img').forEach(image => image.loading = 'lazy');
      this.replaceChildren(content);
      this.hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.sourceTemplate = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
